<div class="flex flex-1">
  @if (loading) {
    <div class="flex flex-1 justify-center items-center">
      <!--
      <dx-load-indicator></dx-load-indicator>
      -->
    </div>
  }
  <ng-template #pdfViewerContainer></ng-template>
</div>
